import i18n from 'scoreboard/components/i18n'
import comparisonStrings from './comparison-strings'
import _ from 'lodash'

var messageCodeMatcher = {

	// note equivalent method in MessageCodeMatcher.java
	codeForInput: function(validCodes, userInput) {
		if (_.isEmpty(validCodes) || _.isEmpty(userInput)) {
			return null
		}

		var userInputResolved = i18n.get(userInput)
		var userInputCompareStr = comparisonStrings.get(userInputResolved)
		for (var i=0; i<validCodes.length; i++) {
			var candidateCode = validCodes[i]
			var candidateResolved = i18n.get(candidateCode)
			var candidateCompareStr = comparisonStrings.get(candidateResolved)
			if (candidateCompareStr == userInputCompareStr) {
				return candidateCode
			}
		}

		return null
	}

}
export default messageCodeMatcher

messageCodeMatcher.__filename__ = 'scorecards/edit/message-code-matcher.js'
